import React from 'react';
import { useA11yDialog } from 'react-a11y-dialog';
import ReactDOM from 'react-dom';
import NewsletterForm from './elements/NewsletterForm';

const NewsletterFormPopup = () => {
  // `instance` is the `a11y-dialog` instance.
  // `attr` is an object with the following keys:
  // - `container`: the dialog container
  // - `overlay`: the dialog overlay (sometimes called backdrop)
  // - `dialog`: the actual dialog box
  // - `title`: the dialog mandatory title
  // - `closeButton`:  the dialog close button
  const [instance, attr] = useA11yDialog({
    // The required HTML `id` attribute of the dialog element, internally used
    // a11y-dialog to manipulate the dialog.
    id: 'newsletter-a11y-dialog',
    role: 'dialog',
  });

  const dialog = ReactDOM.createPortal(
    <div {...attr.container} className="c-dialog c-dialog--newsletter">
      <div {...attr.overlay} className="c-dialog__overlay" />

      <div {...attr.dialog} className="c-dialog__container">
        <div className="c-dialog__content">
          <NewsletterForm />
        </div>

        <button {...attr.closeButton} className="c-dialog__close">
          Close dialog
        </button>
      </div>
    </div>,
    document.getElementById('newsletter-dialog-root')
  );

  return (
    <>
      <button
        type="button"
        onClick={() => instance.show()}
        className="c-header__desktop__toolbar__list__item__btn c-header__desktop__toolbar__list__item__btn--newsletter"
      >
        Newsletter
      </button>
      {dialog}
    </>
  );
};

export default NewsletterFormPopup;
